/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Write_LabelInputs */

const en_us2_board_write_label = /** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your tip or idea`)
};

const pt_br2_board_write_label = /** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua dica ou ideia`)
};

const pt_pt2_board_write_label = /** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua dica ou ideia`)
};

/** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */
const es_419_board_write_label = en_us2_board_write_label;

/** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */
const fr_fr2_board_write_label = en_us2_board_write_label;

/** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */
const de_de2_board_write_label = en_us2_board_write_label;

/** @type {(inputs: Board_Write_LabelInputs) => LocalizedString} */
const it_it2_board_write_label = en_us2_board_write_label;

/**
* | output |
* | --- |
* | "Your tip or idea" |
*
* @param {Board_Write_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_write_label = /** @type {((inputs?: Board_Write_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Write_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_write_label(inputs)
	if (locale === "es-419") return es_419_board_write_label(inputs)
	if (locale === "pt-PT") return pt_pt2_board_write_label(inputs)
	if (locale === "fr-FR") return fr_fr2_board_write_label(inputs)
	if (locale === "de-DE") return de_de2_board_write_label(inputs)
	if (locale === "it-IT") return it_it2_board_write_label(inputs)
	return en_us2_board_write_label(inputs)
});
export { board_write_label as "board.write_label" }